import React, { memo, useImperativeHandle, useRef, forwardRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '@material-ui/core/styles'

import { TextField as TextFieldBase, Label } from './'
import { YDivider } from '../../styles'

const errorMsgFontSize = '12px'
const defaultErrorMsgFixedHeight = '16px'

const TextFieldWithValidation = memo(forwardRef((props, ref) => {
  const [errorMsg, setErrorMsg] = useState('')
  const refTextFieldBase = useRef()
  const value = useRef('')
  const theme = useTheme()
  const errorMsgFixedHeight = props.fixedErrorMessageFieldHeight ? defaultErrorMsgFixedHeight : '0px'

  const onChange = val => {
    value.current = val
    props.onChange && props.onChange(val)
    if (errorMsg !== '') {
      setErrorMsg('')
    }
  }

  useImperativeHandle(ref, () => ({
    focus: () => refTextFieldBase.current.focus(),
    clear: () => { 
      refTextFieldBase.current.setValue('')
      setErrorMsg('')
    },
    getValue: () => value.current,
    setValue: value => {
      refTextFieldBase.current.setValue(value)
      setErrorMsg('')
    },
    validate: () => {
      const error = props.validator(value.current)
      setErrorMsg(error)
      return error === ''
    }
  }))

  const { validator, noTranslateErrorMsg, fixedErrorMessageFieldHeight, inputRef, ...finalProps } = props
  const labelStyle = {
    color: theme.palette.error.light,
    fontSize: errorMsgFontSize,
    height: errorMsgFixedHeight
  }

  return (
    <>
      <TextFieldBase
        {...finalProps}
        ref={refTextFieldBase}
        onChange={onChange}
        error={!!errorMsg}
      />
      {errorMsg 
        ? <Label style={labelStyle} noTranslate={noTranslateErrorMsg}>
          {errorMsg}
        </Label>
        : <YDivider height={errorMsgFixedHeight} />
      }
    </>
  )
}))

TextFieldWithValidation.propTypes = {
  /**
   id for the control.
   */
  id: PropTypes.string,
  validator: PropTypes.func,
  noTranslateErrorMsg: PropTypes.bool,
  fixedErrorMessageFieldHeight: PropTypes.bool,
}

export default TextFieldWithValidation

export const TextFieldOutlinedWithValidation = props =>
  <TextFieldWithValidation
    size='small'
    {...props}
    variant='outlined'
  />

TextFieldOutlinedWithValidation.propTypes = TextFieldWithValidation.propTypes
